import _ from 'lodash';
import { createSelector } from 'reselect';

import { selectCicFeeReasonOptions } from 'store/system/selectors';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanCicFeeReasons = createSelector(
  selectLoanApplication,
  ({ loanCicFeeReasons }) => loanCicFeeReasons,
);

export const selectIsLoanCicFeeReasonExist = createSelector(selectLoanCicFeeReasons, _.size);

export const selectLoanCicFeeReasonOptions = createSelector(
  selectLoanCicFeeReasons,
  loanCicFeeReasons =>
    loanCicFeeReasons.map(({ cicFeeReasonId, name, fees, isDeleted }) => {
      const filteredFees = fees.filter(({ isDeleted }) => !isDeleted);
      const isSomeDeletedFeeInReason = filteredFees.length !== fees.length;

      return {
        name,
        normalizedName: `${name} ${isDeleted ? '(Deleted)' : ''}`,
        value: cicFeeReasonId,
        items: isDeleted ? [] : filteredFees,
        originalItems: fees,
        isDeleted,
        isRequiredToReselect: isDeleted || isSomeDeletedFeeInReason,
      };
    }),
);

const selectDeletedLoanCicFeeReasonOptions = createSelector(
  selectLoanCicFeeReasonOptions,
  loanCicFeeReasonsOptions => loanCicFeeReasonsOptions.filter(({ isDeleted }) => isDeleted),
);

export const selectCicFeeReasonOptionsIncludesDeleted = createSelector(
  [selectCicFeeReasonOptions, selectDeletedLoanCicFeeReasonOptions],
  (cicFeeReasonOptions, deletedLoanCicFeeReasonOptions) =>
    cicFeeReasonOptions
      .map(item => ({ ...item, normalizedName: item.name }))
      .concat(deletedLoanCicFeeReasonOptions),
);

export const selectCicFeeReasonIdsByGroups = createSelector(
  selectLoanCicFeeReasonOptions,
  cicFeeReasons =>
    cicFeeReasons.reduce(
      (acc, { value: cicFeeReasonId, items, isRequiredToReselect }, index, arr) => {
        const isLastElement = index === arr.length - 1;

        items.forEach(({ feeTypeId }) => acc.loanCicFeesIds.push(feeTypeId));
        acc.cicFeeReasonsIds.push(cicFeeReasonId);
        acc.cicFeeReasonsIdsToReselect[cicFeeReasonId] = isRequiredToReselect;

        if (isLastElement) {
          acc.loanCicFeesIds = _.uniq(acc.loanCicFeesIds);
        }

        return acc;
      },
      { loanCicFeesIds: [], cicFeeReasonsIds: [], cicFeeReasonsIdsToReselect: {} },
    ),
);
